import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "ws_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_a073b281-879d-49b3-b9e2-47b67ab08ec4/artifacts/tl6tu3cg_wonderstarz%40300x.png";

export const LIBRARIES = [
  "Clark County Library",
  "West Las Vegas Library",
  "Sahara West Library",
  "Whitney Library",
  "Meadows Library",
];
